export const listDevicesBasic = /* GraphQL */ `
	query DeviceByScheme(
		$schemeId: ID!
		$sortDirection: ModelSortDirection
		$filter: ModelDeviceFilterInput
		$limit: Int
		$nextToken: String
	) {
		deviceByScheme(
			schemeId: $schemeId
			sortDirection: $sortDirection
			filter: $filter
			limit: $limit
			nextToken: $nextToken
		) {
			items {
				id
				name
			}
		}
	}
`;

export const listDevicesAdminTable = /* GraphQL */ `
	query ListDevices($filter: ModelDeviceFilterInput, $limit: Int, $nextToken: String) {
		listDevices(filter: $filter, limit: $limit, nextToken: $nextToken) {
			items {
				id
				name
				schemeId
				scheme {
					id
					name
				}
				reported_state
				updatedAt
				alert {
					sensor_state
				}
			}
			nextToken
		}
	}
`;

export const listDevicesTable = /* GraphQL */ `
	query DeviceByScheme(
		$schemeId: ID!
		$sortDirection: ModelSortDirection
		$filter: ModelDeviceFilterInput
		$limit: Int
		$nextToken: String
	) {
		deviceByScheme(
			schemeId: $schemeId
			sortDirection: $sortDirection
			filter: $filter
			limit: $limit
			nextToken: $nextToken
		) {
			items {
				id
				name
				zone {
					id
					label
				}
				zoneBreadcrumb
				inputDevice
				outputDevice
			}
			nextToken
		}
	}
`;

export const listDevicesTableState = /* GraphQL */ `
	query DeviceByScheme(
		$schemeId: ID!
		$sortDirection: ModelSortDirection
		$filter: ModelDeviceFilterInput
		$limit: Int
		$nextToken: String
	) {
		deviceByScheme(
			schemeId: $schemeId
			sortDirection: $sortDirection
			filter: $filter
			limit: $limit
			nextToken: $nextToken
		) {
			items {
				id
				name
				zone {
					id
					label
				}
				zoneBreadcrumb
				inputDevice
				outputDevice
				reported_state
				updatedAt
			}
			nextToken
		}
	}
`;

export const listDeviceProvisioningsTable = /* GraphQL */ `
	query DeviceProvisioningByScheme(
		$schemeId: ID!
		$sortDirection: ModelSortDirection
		$filter: ModelDeviceProvisioningFilterInput
		$limit: Int
		$nextToken: String
	) {
		deviceProvisioningByScheme(
			schemeId: $schemeId
			sortDirection: $sortDirection
			filter: $filter
			limit: $limit
			nextToken: $nextToken
		) {
			items {
				id
				name
				inputDevice
				outputDevice
				zone {
					label
				}
				createdAt
				installerId
			}
		}
	}
`;

export const listDevicesAlarmGroup = /* GraphQL */ `
	query DeviceByScheme(
		$schemeId: ID!
		$sortDirection: ModelSortDirection
		$filter: ModelDeviceFilterInput
		$limit: Int
		$nextToken: String
	) {
		deviceByScheme(
			schemeId: $schemeId
			sortDirection: $sortDirection
			filter: $filter
			limit: $limit
			nextToken: $nextToken
		) {
			items {
				id
				name
				zone {
					label
				}
				inputDevice
				outputDevice
				reported_state
				alert {
					sensor_state
				}
			}
		}
	}
`;

export const listDevicesState = /* GraphQL */ `
	query DeviceByScheme(
		$schemeId: ID!
		$sortDirection: ModelSortDirection
		$filter: ModelDeviceFilterInput
		$limit: Int
		$nextToken: String
	) {
		deviceByScheme(
			schemeId: $schemeId
			sortDirection: $sortDirection
			filter: $filter
			limit: $limit
			nextToken: $nextToken
		) {
			items {
				id
				name
				reported_state
				updatedAt
				zone {
					id
					label
				}
			}
			nextToken
		}
	}
`;

export const listAlarmGroupsTable = /* GraphQL */ `
	query ListAlarmGroups($filter: ModelAlarmGroupFilterInput, $limit: Int, $nextToken: String) {
		listAlarmGroups(filter: $filter, limit: $limit, nextToken: $nextToken) {
			items {
				id
				name
				input {
					items {
						id
						deviceID
						alarmGroupID
						__typename
					}
					nextToken
					__typename
				}
				output {
					items {
						id
						deviceID
						alarmGroupID
						__typename
					}
					nextToken
					__typename
				}
				schemeId
				createdAt
				updatedAt
				__typename
			}
			nextToken
			__typename
		}
	}
`;

export const listAlarmGroupsInputIds = /* GraphQL */ `
	query ListAlarmGroupsInputs($filter: ModelAlarmGroupsInputFilterInput, $limit: Int, $nextToken: String) {
		listAlarmGroupsInputs(filter: $filter, limit: $limit, nextToken: $nextToken) {
			items {
				id
			}
		}
	}
`;

export const listAlarmGroupsOutputIds = /* GraphQL */ `
	query ListAlarmGroupsOutputs($filter: ModelAlarmGroupsOutputFilterInput, $limit: Int, $nextToken: String) {
		listAlarmGroupsOutputs(filter: $filter, limit: $limit, nextToken: $nextToken) {
			items {
				id
			}
		}
	}
`;

export const validateDeviceName = /* GraphQL */ `
	query DeviceByName(
		$name: String!
		$schemeId: ModelIDKeyConditionInput
		$sortDirection: ModelSortDirection
		$filter: ModelDeviceFilterInput
		$limit: Int
		$nextToken: String
	) {
		deviceByName(
			name: $name
			schemeId: $schemeId
			sortDirection: $sortDirection
			filter: $filter
			limit: $limit
			nextToken: $nextToken
		) {
			items {
				id
				name
			}
		}
	}
`;

export const validateSchemeName = /* GraphQL */ `
	query SchemeByName(
		$name: String!
		$sortDirection: ModelSortDirection
		$filter: ModelSchemeFilterInput
		$limit: Int
		$nextToken: String
	) {
		schemeByName(
			name: $name
			sortDirection: $sortDirection
			filter: $filter
			limit: $limit
			nextToken: $nextToken
		) {
			items {
				id
				name
			}
		}
	}
`;

export const validateZoneName = /* GraphQL */ `
	query ZoneByLabel(
		$label: String!
		$schemeId: ModelIDKeyConditionInput
		$sortDirection: ModelSortDirection
		$filter: ModelZoneFilterInput
		$limit: Int
		$nextToken: String
	) {
		zoneByLabel(
			label: $label
			schemeId: $schemeId
			sortDirection: $sortDirection
			filter: $filter
			limit: $limit
			nextToken: $nextToken
		) {
			items {
				id
				label
			}
		}
	}
`;

export const listAlarmAlerts = /* GraphQL */ `
	query DeviceSensorAlertBySensorState(
		$sensor_state: Int!
		$sortDirection: ModelSortDirection
		$filter: ModelDeviceSensorAlertFilterInput
		$limit: Int
		$nextToken: String
	) {
		deviceSensorAlertBySensorState(
			sensor_state: $sensor_state
			sortDirection: $sortDirection
			filter: $filter
			limit: $limit
			nextToken: $nextToken
		) {
			items {
				sensor_state
				updatedAt
				id
				device {
					id
					name
					inputDevice
					reported_state
					updatedAt
					zone {
						label
					}
					zoneBreadcrumb
					alarmGroupsOutput {
						items {
							alarmGroup {
								id
								name
							}
						}
					}
					alarmGroupsInput {
						items {
							alarmGroup {
								id
								name
								output {
									items {
										device {
											id
											name
											reported_state
											alarmGroupsOutput {
												items {
													alarmGroup {
														name
													}
												}
											}
										}
									}
								}
							}
						}
					}
				}
			}
		}
	}
`;

export const getDeviceFlowstops = /* GraphQL */ `
	query GetDevice($id: ID!) {
		getDevice(id: $id) {
			id
			alarmGroupsInput {
				items {
					alarmGroup {
						id
						name
						output {
							items {
								device {
									id
									name
									reported_state
									alarmGroupsOutput {
										items {
											alarmGroup {
												name
											}
										}
									}
								}
							}
						}
					}
				}
			}
		}
	}
`;

export const getDeviceSensors = /* GraphQL */ `
	query GetDevice($id: ID!) {
		getDevice(id: $id) {
			id
			alarmGroupsOutput {
				items {
					alarmGroup {
						id
						name
						input {
							items {
								device {
									id
									name
									inputDevice
								}
							}
						}
					}
				}
			}
		}
	}
`;

export const getUserConfigs = /* GraphQL */ `
	query UserSchemeConfigByCognitoUserId(
		$cognitoUserId: String!
		$sortDirection: ModelSortDirection
		$filterScheme: ModelUserSchemeConfigFilterInput
		$filterNotify: ModelUserNotifyConfigFilterInput
		$limit: Int
		$nextToken: String
	) {
		userSchemeConfigByCognitoUserId(
			cognitoUserId: $cognitoUserId
			sortDirection: $sortDirection
			filter: $filterScheme
			limit: $limit
			nextToken: $nextToken
		) {
			items {
				id
				role
			}
		}
		userNotifyConfigByCognitoUserId(
			cognitoUserId: $cognitoUserId
			sortDirection: $sortDirection
			filter: $filterNotify
			limit: $limit
			nextToken: $nextToken
		) {
			items {
				id
			}
		}
	}
`;

export const listTenantsByScheme = /* GraphQL */ `
	query UserSchemeConfigBySchemeId(
		$schemeId: ID!
		$cognitoUserId: ModelStringKeyConditionInput
		$sortDirection: ModelSortDirection
		$filter: ModelUserSchemeConfigFilterInput
		$limit: Int
		$nextToken: String
	) {
		userSchemeConfigBySchemeId(
			schemeId: $schemeId
			cognitoUserId: $cognitoUserId
			sortDirection: $sortDirection
			filter: $filter
			limit: $limit
			nextToken: $nextToken
		) {
			items {
				id: cognitoUserId
			}
		}
	}
`;

export const getSchemeZoneConfig = /* GraphQL */ `
	query GetScheme($id: ID!) {
		getScheme(id: $id) {
			zoneConfig
		}
	}
`;

export const getSchemeForAdmin = /* GraphQL */ `
	query GetScheme($id: ID!) {
		getScheme(id: $id) {
			id
			name
			users {
				items {
					id
					cognitoUserId
					schemeId
					isDefaultScheme
					role
					createdAt
					updatedAt
				}
			}
			contact
			contactEmergency
			zoneConfig
			createdBy
			updatedBy
			createdAt
			updatedAt
		}
	}
`;

export const getAlarmGroupForEdit = /* GraphQL */ `
	query GetAlarmGroup($id: ID!) {
		getAlarmGroup(id: $id) {
			id
			name
			schemeId
			input {
				items {
					id
					deviceID
					alarmGroupID
				}
			}
			output {
				items {
					id
					deviceID
					alarmGroupID
				}
			}
		}
	}
`;

export const listZonesBasic = /* GraphQL */ `
	query ZoneBySchemeId(
		$schemeId: ID!
		$sortDirection: ModelSortDirection
		$filter: ModelZoneFilterInput
		$limit: Int
		$nextToken: String
	) {
		zoneBySchemeId(
			schemeId: $schemeId
			sortDirection: $sortDirection
			filter: $filter
			limit: $limit
			nextToken: $nextToken
		) {
			items {
				id
				label
				type
				parent
				tenant
				devices {
					items {
						id
						name
					}
				}
			}
		}
	}
`;

export const getZoneWithDeviceState = /* GraphQL */ `
	query GetZone($id: ID!) {
		getZone(id: $id) {
			id
			label
			type
			parent
			tenant
			createdBy
			updatedBy
			createdAt
			updatedAt
			devices {
				items {
					id
					name
					reported_state
					updatedAt
				}
			}
		}
	}
`;

export const getZoneBasic = /* GraphQL */ `
	query GetZone($id: ID!) {
		getZone(id: $id) {
			id
			label
			type
			devices {
				items {
					id
					name
					inputDevice
					outputDevice
				}
			}
			parent
			tenant
			createdBy
			updatedBy
			createdAt
			updatedAt
		}
	}
`;

export const liveEventBySchemeBasic = /* GraphQL */ `
	query LiveEventByScheme(
		$schemeId: ID!
		$updatedAtCreatedAt: ModelLiveEventBySchemeCompositeKeyConditionInput
		$sortDirection: ModelSortDirection
		$filter: ModelLiveEventFilterInput
		$limit: Int
		$nextToken: String
	) {
		liveEventByScheme(
			schemeId: $schemeId
			updatedAtCreatedAt: $updatedAtCreatedAt
			sortDirection: $sortDirection
			filter: $filter
			limit: $limit
			nextToken: $nextToken
		) {
			items {
				id
				schemeId
				deviceId
				device {
					id
					name
					zone {
						label
					}
					zoneBreadcrumb
				}
				eventType
				duration
				createdAt
				updatedAt
			}
			nextToken
		}
	}
`;

export const archiveEventBySchemeBasic = /* GraphQL */ `
	query ArchiveEventByScheme(
		$schemeId: ID!
		$updatedAtCreatedAt: ModelArchiveEventBySchemeCompositeKeyConditionInput
		$sortDirection: ModelSortDirection
		$filter: ModelArchiveEventFilterInput
		$limit: Int
		$nextToken: String
	) {
		archiveEventByScheme(
			schemeId: $schemeId
			updatedAtCreatedAt: $updatedAtCreatedAt
			sortDirection: $sortDirection
			filter: $filter
			limit: $limit
			nextToken: $nextToken
		) {
			items {
				id
				schemeId
				deviceId
				device {
					id
					name
					zone {
						label
					}
					zoneBreadcrumb
				}
				eventType
				duration
				createdAt
				updatedAt
			}
			nextToken
		}
	}
`;

export const LiveEventBySchemeSummary = /* GraphQL */ `
	query LiveEventByScheme(
		$schemeId: ID!
		$updatedAtCreatedAt: ModelLiveEventBySchemeCompositeKeyConditionInput
		$sortDirection: ModelSortDirection
		$filter: ModelLiveEventFilterInput
		$limit: Int
		$nextToken: String
	) {
		liveEventByScheme(
			schemeId: $schemeId
			updatedAtCreatedAt: $updatedAtCreatedAt
			sortDirection: $sortDirection
			filter: $filter
			limit: $limit
			nextToken: $nextToken
		) {
			items {
				id
				eventType
				updatedAt
			}
			nextToken
		}
	}
`;

export const ArchiveEventBySchemeSummary = /* GraphQL */ `
	query ArchiveEventByScheme(
		$schemeId: ID!
		$updatedAtCreatedAt: ModelArchiveEventBySchemeCompositeKeyConditionInput
		$sortDirection: ModelSortDirection
		$filter: ModelArchiveEventFilterInput
		$limit: Int
		$nextToken: String
	) {
		archiveEventByScheme(
			schemeId: $schemeId
			updatedAtCreatedAt: $updatedAtCreatedAt
			sortDirection: $sortDirection
			filter: $filter
			limit: $limit
			nextToken: $nextToken
		) {
			items {
				id
				eventType
				updatedAt
			}
			nextToken
		}
	}
`;

export const getAlarmGroupDetails = /* GraphQL */ `
	query GetAlarmGroup($id: ID!) {
		getAlarmGroup(id: $id) {
			id
			name
			schemeId
			input {
				items {
					deviceID
					device {
						id
						name
						inputDevice
						zone {
							label
						}
						reported_state
						updatedAt
					}
				}
			}
			output {
				items {
					deviceID
					device {
						id
						name
						outputDevice
						zone {
							label
						}
						reported_state
						updatedAt
					}
				}
			}
		}
	}
`;

export const liveEventByDeviceBasic = /* GraphQL */ `
	query LiveEventByDevice(
		$deviceId: ID!
		$updatedAtCreatedAt: ModelLiveEventByDeviceCompositeKeyConditionInput
		$sortDirection: ModelSortDirection
		$filter: ModelLiveEventFilterInput
		$limit: Int
		$nextToken: String
	) {
		liveEventByDevice(
			deviceId: $deviceId
			updatedAtCreatedAt: $updatedAtCreatedAt
			sortDirection: $sortDirection
			filter: $filter
			limit: $limit
			nextToken: $nextToken
		) {
			items {
				id
				deviceId
				eventType
				duration
				createdAt
				updatedAt
			}
		}
	}
`;

export const archiveEventByDeviceBasic = /* GraphQL */ `
	query ArchiveEventByDevice(
		$deviceId: ID!
		$updatedAtCreatedAt: ModelArchiveEventByDeviceCompositeKeyConditionInput
		$sortDirection: ModelSortDirection
		$filter: ModelArchiveEventFilterInput
		$limit: Int
		$nextToken: String
	) {
		archiveEventByDevice(
			deviceId: $deviceId
			updatedAtCreatedAt: $updatedAtCreatedAt
			sortDirection: $sortDirection
			filter: $filter
			limit: $limit
			nextToken: $nextToken
		) {
			items {
				id
				deviceId
				eventType
				duration
				createdAt
				updatedAt
			}
		}
	}
`;

export const getAlarmGroupInputOutputs = /* GraphQL */ `
	query GetDevice($id: ID!) {
		getDevice(id: $id) {
			id
			alarmGroupsInput {
				items {
					alarmGroup {
						id
						output {
							items {
								deviceID
								device {
									reported_state
								}
							}
						}
					}
				}
			}
		}
	}
`;

export const getAlarmGroupOutputInputs = /* GraphQL */ `
	query GetDevice($id: ID!) {
		getDevice(id: $id) {
			id
			alarmGroupsOutput {
				items {
					alarmGroup {
						id
						input {
							items {
								deviceID
								device {
									reported_state
								}
							}
						}
					}
				}
			}
		}
	}
`;

export const listUserSchemeConfigsBasic = /* GraphQL */ `
	query ListUserSchemeConfigs($filter: ModelUserSchemeConfigFilterInput, $limit: Int, $nextToken: String) {
		listUserSchemeConfigs(filter: $filter, limit: $limit, nextToken: $nextToken) {
			items {
				id
				cognitoUserId
				role
			}
		}
	}
`;

//Only the fields needed to answer "is this device offline, and since when". The nested device
//object that liveEventBySchemeBasic returns is not fetched, because every screen asking this
//question already holds the device record.
export const liveEventCommsByScheme = /* GraphQL */ `
	query LiveEventByScheme($schemeId: ID!, $filter: ModelLiveEventFilterInput, $limit: Int, $nextToken: String) {
		liveEventByScheme(schemeId: $schemeId, filter: $filter, limit: $limit, nextToken: $nextToken) {
			items {
				deviceId
				createdAt
				updatedAt
			}
			nextToken
		}
	}
`;

export const getUserNotifyConfigBasic = /* GraphQL */ `
	query GetUserNotifyConfigBasic($id: ID!) {
		getUserNotifyConfig(id: $id) {
			id
			cognitoUserId
			schemeId
			config
		}
	}
`;
